import { render, staticRenderFns } from "./InvestorBusinessFiscalRecordDocument.vue?vue&type=template&id=f5d08cc6&"
import script from "./InvestorBusinessFiscalRecordDocument.vue?vue&type=script&lang=js&"
export * from "./InvestorBusinessFiscalRecordDocument.vue?vue&type=script&lang=js&"
import style0 from "./InvestorBusinessFiscalRecordDocument.vue?vue&type=style&index=0&id=f5d08cc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports